import React from "react";
import { useErrorBoundary } from "react-error-boundary";
import useAxios from "axios-hooks";

import { Loading } from "affinityUI/elements/loading";

export const CsrfLoader: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { showBoundary: onError } = useErrorBoundary();
  const [{ response, error, loading }] = useAxios("/api/v1/status/");
  if (loading) {
    return <Loading />;
  }
  if (error) {
    onError(error);
  }
  return response?.status === 200 ? <>{children}</> : <Loading />;
};
